import React from 'react';
import { Form, Col, Row, DatePicker, Radio, Select } from 'antd';
import '../App.css';
import 'antd/dist/antd.css'; 
import 'moment/locale/es';
import locale from 'antd/es/date-picker/locale/es_ES';
//Seleccionar regimenes en los que aportaste
const {Item} = Form;

function App() {
  
  const {Option}=Select;

  const layout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 8,
    },
  };

  return (

    <div>

     <Row>
        <Col xs={1} sm={1} md={2} lg={5} ></Col>

        <Col xs={22} sm={22} md={20} lg={14} >

          <Form name="formulario" {...layout}>                                                  
                                    
              <Item name="fechaCalculo" label="Fecha de calculo"  rules={[{required:true,message:"Por favor ingrese la fecha de calculo"}]}> <DatePicker style={{ width: '190px', float: 'left' }} locale={locale}/> </Item>
              <Item name="fechaNacimiento" label="Fecha de nacimiento"  rules={[{required:true,message:"Por favor ingrese la fecha de nacimiento"}]}> <DatePicker style={{ width: '190px', float: 'left' }} locale={locale}/> </Item>
              <Item name="sexo" label="Sexo" rules={[{required:true,message:"Por favor seleccione su sexo "}]}> <Radio.Group style={{ width: '190px', float: 'left' }} defaultValue="m" buttonStyle="solid"> <Radio.Button   value="m">Masculino</Radio.Button> <Radio.Button value="f">Femenino</Radio.Button> </Radio.Group> </Item>
              <Item name="regimen" label="Seleccione regimen/es" rules={[{required:true,message:""}]}>
                  <Select style={{ width: 190, float: 'left' }}  placeholder="Seleccione">
                    <Option value="1">Relación de dependencia</Option>
                    <Option value="2">Autónomo</Option>
                    <Option value="3">Ambos</Option>
                  </Select>   
              </Item>

          </Form>

        </Col>

        <Col xs={1} sm={1} md={2} lg={5} ></Col>
     </Row>
    </div>

);}

export default App;